<div class="products-page-header">
  <div class="products-page-header__main">
    <h4 class="page-title">
      <i class="fas fa-box-open"></i>
      Produtos
      <span *ngIf="empresa?.catalogo?.compartilhado" class="badge badge-danger badge-sm ml-1" >catálogo compartilhado</span>
    </h4>

    <button class="btn btn-outline-primary" *ngIf="temModuloTabelaPrecos" (click)="abraTabelaPrecos()">
      <i class="fas fa-tags mr-1"></i>
      Tabelas preços
    </button>

    <a class="btn btn-outline-primary" href="/admin/produtos-v2" title="Experimentar o editor de produtos V2">
      <i class="fe-zap mr-1"></i>
      <span>Produtos V2</span>
    </a>
  </div>

  <div class="products-page-header__danger"
       *ngIf="usuario.admin"
       [hidden]="confirmeRemover || confirmeRestaurar">
    <div class="dropdown">
      <button class="btn btn-light dropdown-toggle"
              type="button"
              id="catalogToolsMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false">
        <i class="fas fa-cog mr-1"></i>
        Ferramentas
      </button>

      <div class="dropdown-menu dropdown-menu-right catalog-tools-menu"
           aria-labelledby="catalogToolsMenuButton">
        <h6 class="dropdown-header">Manutenção</h6>
        <button type="button"
                class="dropdown-item cpointer"
                (click)="limparCache()">
          <i class="fas fa-broom mr-2"></i>
          Limpar cache
        </button>

        <ng-container *ngIf="remocoesCatalogoPendentes.length">
          <div class="dropdown-divider"></div>
          <h6 class="dropdown-header">Recuperação</h6>
          <button type="button"
                  class="dropdown-item cpointer"
                  (click)="abraRestaurarCatalogo()">
            <i class="fas fa-undo mr-2"></i>
            Restaurar catálogo
          </button>
        </ng-container>

        <ng-container *ngIf="totalProdutosCatalogo > 0">
          <div class="dropdown-divider"></div>
          <h6 class="dropdown-header text-danger">Zona de risco</h6>
          <button type="button"
                  class="dropdown-item catalog-tools-menu__danger cpointer"
                  (click)="removerCatalogo()">
            <i class="fas fa-trash-alt mr-2"></i>
            Limpar catálogo
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<div class="alert alert-warning" *ngIf="empresa?.id && empresa?.catalogo?.compartilhado">
  <i class="fa fa-lock mr-1"></i>
  <strong>Catálogo controlado pela rede.</strong>
  Algumas informações dos produtos são administradas no Admin Rede. Para alterar dados bloqueados, solicite a edição ao responsável pelo catálogo da rede.
</div>

<div class="row" *ngIf="empresa?.catalogo">
 <div class="card-box" style="width: 100%;">
   <app-produtos2 #telaProdutos
                  [empresa]="empresa"
                  [catalogo]="empresa.catalogo"
                  (onCarregouProdutos)="atualizeTotalProdutos($event)"></app-produtos2>
 </div>
</div>

<kendo-dialog *ngIf="confirmeRemover"
              (close)="canceleRemoverCatalogo()"
              [minWidth]="320"
              [width]="650">
  <kendo-dialog-titlebar (close)="canceleRemoverCatalogo()">
    <div class="d-flex align-items-center">
      <i class="fas fa-exclamation-triangle text-danger mr-2"></i>
      Limpar catálogo
    </div>
  </kendo-dialog-titlebar>

  <div class="clear-catalog-dialog">
    <div class="alert alert-warning d-flex align-items-start mb-4">
      <i class="fas fa-exclamation-triangle fa-2x mr-3 text-warning"></i>
      <div>
        <h5 class="alert-heading">Atenção: exclusão permanente</h5>
        <p>
          Ao confirmar, o catálogo da empresa <strong>{{empresa?.nome}}</strong> ficará vazio.
          O sistema apagará:
        </p>
        <ul>
          <li><strong>todos os produtos</strong> e suas configurações;</li>
          <li><strong>todas as categorias</strong> do catálogo;</li>
          <li><strong>todas as disponibilidades</strong> configuradas para o catálogo.</li>
        </ul>
        <hr>
        <p class="mb-0 text-danger font-weight-bold">
          <i class="fas fa-info-circle mr-1"></i>
          A limpeza ficará registrada e poderá ser restaurada enquanto o catálogo estiver vazio.
        </p>
      </div>
    </div>

    <div class="clear-catalog-dialog__confirmation">
      <label for="confirmacaoLimparCatalogo" class="font-weight-bold">
        Para confirmar, digite exatamente:
      </label>

      <div class="text-center my-3">
        <code>{{fraseConfirmacaoCatalogo}}</code>
      </div>

      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="fas fa-keyboard"></i>
          </span>
        </div>
        <input id="confirmacaoLimparCatalogo"
               name="confirmacaoLimparCatalogo"
               type="text"
               class="form-control form-control-lg"
               [ngModel]="textoConfirmacaoCatalogo"
               (ngModelChange)="textoConfirmacaoCatalogo = ($event || '').toUpperCase()"
               [class.is-valid]="digitouConfirmacaoCatalogo()"
               [class.is-invalid]="textoConfirmacaoCatalogo && !digitouConfirmacaoCatalogo()"
               [disabled]="removendo"
               placeholder="Digite LIMPAR CATALOGO"
               autocomplete="off"
               spellcheck="false"
               appAutoFocus>
        <div class="input-group-append" *ngIf="digitouConfirmacaoCatalogo()">
          <span class="input-group-text text-success">
            <i class="fas fa-check"></i>
          </span>
        </div>
      </div>

      <small class="form-text text-muted">
        O texto digitado é convertido automaticamente para maiúsculas.
      </small>
    </div>

    <div class="alert alert-danger mt-3 mb-0" *ngIf="erroRemoverCatalogo">
      <i class="fas fa-times-circle mr-2"></i>
      {{erroRemoverCatalogo}}
    </div>
  </div>

  <kendo-dialog-actions>
    <button kendoButton
            type="button"
            (click)="canceleRemoverCatalogo()"
            [disabled]="removendo">
      Cancelar
    </button>
    <button kendoButton
            type="button"
            [primary]="true"
            class="btn-danger"
            (click)="removaCatalogo()"
            [disabled]="removendo || !digitouConfirmacaoCatalogo()">
      <i class="k-icon k-i-loading mr-2" *ngIf="removendo"></i>
      {{removendo ? 'Limpando catálogo...' : 'Limpar catálogo'}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog *ngIf="confirmeRestaurar"
              (close)="canceleRestaurarCatalogo()"
              [minWidth]="320"
              [width]="650">
  <kendo-dialog-titlebar (close)="canceleRestaurarCatalogo()">
    <div class="d-flex align-items-center">
      <i class="fas fa-undo text-primary mr-2"></i>
      Restaurar catálogo removido
    </div>
  </kendo-dialog-titlebar>

  <div class="restore-catalog-dialog">
    <div class="alert alert-info mb-4">
      <h5 class="alert-heading">
        <i class="fas fa-history mr-2"></i>
        Escolha a limpeza que deseja restaurar
      </h5>
      <p class="mb-0">
        A restauração reativa os produtos, categorias, disponibilidades e templates,
        recuperando também a categoria e a ordem anterior de cada produto.
      </p>
    </div>

    <div class="form-group">
      <label for="historicoCatalogo" class="font-weight-bold">Histórico da limpeza</label>
      <select id="historicoCatalogo"
              name="historicoCatalogo"
              class="form-control"
              [(ngModel)]="historicoCatalogoSelecionado"
              [disabled]="restaurandoCatalogo">
        <option *ngFor="let historico of remocoesCatalogoPendentes" [ngValue]="historico">
          {{historico.dataRemocao | date:'dd/MM/yyyy HH:mm'}} —
          {{historico.nomeUsuario || 'Usuário não informado'}} —
          {{historico.totalProdutos}} produto(s)
        </option>
      </select>
    </div>

    <div class="restore-catalog-dialog__summary" *ngIf="historicoCatalogoSelecionado">
      <div>
        <strong>{{historicoCatalogoSelecionado.totalProdutos}}</strong>
        <span>Produtos</span>
      </div>
      <div>
        <strong>{{historicoCatalogoSelecionado.totalCategorias}}</strong>
        <span>Categorias</span>
      </div>
      <div>
        <strong>{{historicoCatalogoSelecionado.totalDisponibilidades}}</strong>
        <span>Disponibilidades</span>
      </div>
    </div>

    <div class="alert alert-warning">
      <i class="fas fa-exclamation-triangle mr-2"></i>
      A restauração somente é permitida quando o catálogo atual está vazio, evitando misturar
      registros antigos com um catálogo novo.
    </div>

    <div class="form-group mb-0">
      <label for="confirmacaoRestaurarCatalogo" class="font-weight-bold">
        Para confirmar, digite exatamente:
      </label>

      <div class="text-center my-3">
        <code>{{fraseConfirmacaoRestauracao}}</code>
      </div>

      <input id="confirmacaoRestaurarCatalogo"
             name="confirmacaoRestaurarCatalogo"
             type="text"
             class="form-control form-control-lg"
             [ngModel]="textoConfirmacaoRestauracao"
             (ngModelChange)="textoConfirmacaoRestauracao = ($event || '').toUpperCase()"
             [class.is-valid]="digitouConfirmacaoRestauracao()"
             [class.is-invalid]="textoConfirmacaoRestauracao && !digitouConfirmacaoRestauracao()"
             [disabled]="restaurandoCatalogo"
             placeholder="Digite RESTAURAR CATALOGO"
             autocomplete="off"
             spellcheck="false">
    </div>

    <div class="alert alert-danger mt-3 mb-0" *ngIf="erroRestaurarCatalogo">
      <i class="fas fa-times-circle mr-2"></i>
      {{erroRestaurarCatalogo}}
    </div>
  </div>

  <kendo-dialog-actions>
    <button kendoButton
            type="button"
            (click)="canceleRestaurarCatalogo()"
            [disabled]="restaurandoCatalogo">
      Cancelar
    </button>
    <button kendoButton
            type="button"
            [primary]="true"
            (click)="restaureCatalogo()"
            [disabled]="restaurandoCatalogo || !historicoCatalogoSelecionado ||
                        !digitouConfirmacaoRestauracao()">
      <i class="k-icon k-i-loading mr-2" *ngIf="restaurandoCatalogo"></i>
      {{restaurandoCatalogo ? 'Restaurando catálogo...' : 'Restaurar catálogo'}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
